/**
 * GLOBAL Automation Technologies wordmark.
 * SVG recreation; replace with real PNG/SVG asset if/when supplied.
 */
export function GlobalLogo({ tone = 'dark', className }) {
  const wordColor = tone === 'dark' ? '#43A047' : '#2E7D32';
  const ringColor = tone === 'dark' ? '#FFFFFF' : '#1A1A1A';
  const subColor = tone === 'dark' ? 'rgba(255,255,255,.55)' : '#888';
  return (
    <svg viewBox="0 0 240 64" xmlns="http://www.w3.org/2000/svg" aria-label="GLOBAL Automation Technologies" className={className}>
      <text x="0" y="38" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="36" letterSpacing="-1" fill={wordColor}>
        G
      </text>
      <text x="29" y="38" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="36" letterSpacing="-1" fill={wordColor}>
        L
      </text>
      <g transform="translate(55,8)">
        <circle cx="16" cy="16" r="14" fill="none" stroke={wordColor} strokeWidth="6" />
        <ellipse cx="16" cy="16" rx="20" ry="6" fill="none" stroke={ringColor} strokeWidth="3" transform="rotate(-28 16 16)" />
      </g>
      <text x="92" y="38" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="36" letterSpacing="-1" fill={wordColor}>
        B
      </text>
      <text x="117" y="38" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="36" letterSpacing="-1" fill={wordColor}>
        A
      </text>
      <text x="143" y="38" fontFamily="Inter, sans-serif" fontWeight="800" fontSize="36" letterSpacing="-1" fill={wordColor}>
        L
      </text>
      <text x="0" y="58" fontFamily="Inter, sans-serif" fontWeight="600" fontSize="9" letterSpacing="2.5" fill={subColor}>
        AUTOMATION TECHNOLOGIES
      </text>
    </svg>
  );
}
